import { Icons } from '../../atoms/icons';
import { IBtnFinancingInterface } from './btnFinancing.interface';
import styles from './btnFinancing.module.scss';

export const BtnFinancing = (props: IBtnFinancingInterface) => {
	const { text, icon, onSelectEvaluation, type } = props;

	return (
		<div className={styles['btn-action-content']}>
			<a href='#' onClick={ onSelectEvaluation } data-type={ type }>
				<Icons iconName={ icon } />
				<p> {text} </p>
			</a>
		</div>
	)
}
